import * as Sentry from '@sentry/react';
import { AxiosError } from 'axios';
import { getItem } from '@/utils/localstorage';
import { axiosClient } from './axiosClient';

const getWarningType = (config: any) => {
  let warningType = 'Unset';
  
  if (config.data?.photo) {
    warningType = 'Photo';
  } else if (config.data?.optIn) {
    warningType = 'Opt In';
  } else if (config.data?.firstName || config.data?.lastName) {
    warningType = 'Name Change';
  } else if (config.data?.url?.includes('emailVerification')) {
    warningType = 'Email Verification';
  }
  
  return warningType;
};

axiosClient.interceptors.request.use(
  async (config) => {
    const url = config.url || '';
    config.headers.appPlatform = 'web-public';
    config.headers.apiVersion = 1.9;
    config.headers.client = getItem('client');
    config.headers.Authorization = `Bearer ${getItem('token')}`;

    // Check for missing required headers
    const requiredHeaders = ['appPlatform', 'apiVersion', 'client'];
    const missingHeaders = requiredHeaders.filter((header) => !config.headers?.[header]);
    const warningType = getWarningType(config);

    if (missingHeaders.length > 0 && !url?.includes('site') && warningType !== 'Unset') {
      Sentry.captureMessage('Missing required headers in API request', (scope) => {
        scope.setLevel('warning');
        scope.setExtras({
          missingHeaders,
          method: config.method,
          url: config.url,
          headers: config.headers,
        });
        scope.setTag('api_validation', warningType);
        return scope;
      });
    }

    return config;
  },
  (error) => Promise.reject(error)
);

axiosClient.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => Promise.reject(error)
);

export default axiosClient;
